import React, { useState, useEffect } from "react";
import styles from "./Component/CSS/GarhwaliShortStories.module.css";
import AudiosUI from "../UI/Audios/AudiosUI";
import { useNavigate } from "react-router-dom";
import Loading from "../common/HousGlass Loader/Loading";
import { useAudiosByGenre } from "../hooks/useAudiosHooks";

const GarhwaliCategories = ({ categories }) => {
  const [visibleBooks, setVisibleBooks] = useState(100);
  const navigate = useNavigate();

  // Handler for when a card is clicked
  const handleCardClick = (audio) => {
    navigate(`/audio-play/${audio.slug}`);
  };

  // Filter out categories with name "Podcast"
  const filteredCategories = categories ? categories.filter(category => category.name !== "Podcast") : [];

  // We'll return a component for each category
  return (
    <div>
      {filteredCategories && filteredCategories.length > 0 ? (
        filteredCategories.map((category) => (
          <CategorySection
            key={category.id}
            category={category}
            visibleBooks={visibleBooks}
            setVisibleBooks={setVisibleBooks}
            handleCardClick={handleCardClick}
          />
        ))
      ) : (
        <div className={styles.noCategories}>No categories available</div>
      )}
    </div>
  );
};

// Separate component for each category section to manage its own data loading
const CategorySection = ({
  category,
  visibleBooks,
  setVisibleBooks,
  handleCardClick,
}) => {
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const {
    data: responseData,
    isLoading,
    isError,
    error,
  } = useAudiosByGenre(category.id, { limit: visibleBooks });

  const [audios, setAudios] = useState([]);
  const [pagination, setPagination] = useState({ total: 0 });

  // Process data when it changes
  useEffect(() => {
    if (responseData) {
      // Extract the data array and pagination object
      if (responseData.data && Array.isArray(responseData.data)) {
        setAudios(responseData.data);
      }

      if (responseData.pagination) {
        setPagination(responseData.pagination);
      }
    }
  }, [responseData]);

  // Reset loading more state when data changes
  useEffect(() => {
    if (isLoadingMore && responseData) {
      setIsLoadingMore(false);
    }
  }, [responseData, isLoadingMore]);

  // Show loading state
  if (isLoading && !isLoadingMore && !audios.length) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  // Show error state
  if (isError) {
    return (
      <div className={styles.error}>
        Error: {error?.message || "Failed to load content"}
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.boxedWrapper}>
        {/* Audio grid container */}
        <div className={styles.audioGridContainer}>
          {audios && audios.length > 0 ? (
            <div className={styles.audioGrid}>
              {audios.map((audio) => (
                <div key={audio.id} className={styles.gridItem}>
                  <AudiosUI
                    title={audio.title}
                    image={audio.computer_image_url || audio.mobile_image_url || "/placeholder-image.jpg"}
                    onClick={() => handleCardClick(audio)}
                    imageFit="contain"
                    square
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.noContent}>
              No audios available in this category
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GarhwaliCategories;